import React from 'react';

const t = (field, lang = 'en') => {
  if (!field) return '';
  if (typeof field === 'string') return field;
  return field[lang] || field.en || '';
};

export default function CTA({ content, scrollTo, lang = 'en' }) {
  const rawTitle = t(content?.ctaTitleRegular, lang) || "Your Dance Story\nStarts ";
  const titleParts = rawTitle.replace(/\\n/g, '\n').split('\n');

  return (
    <div className="lp-cta-sec">
      <div className="reveal">
        <div className="lp-overline lp-overline-dim">
          {t(content?.ctaOverline, lang) || "Join ETS Academy Today"}
        </div>
        <h2>
          {titleParts[0]}
          {titleParts.length > 1 && <><br/>{titleParts[1]}</>}
          <em>{t(content?.ctaTitleItalic, lang) || "Today"}</em>
        </h2>
        <p className="lp-cta-sub">
          {t(content?.ctaSubtext, lang) || t({ en: 'Join 12,000+ dancers training smarter, improving faster, and loving every step with Every Talent Shines Academy.', zh: '與 12,000 多名舞者一起在 Every Talent Shines 舞蹈學院接受更聰明的訓練，進步更快，並熱愛每一步。' }, lang)}
        </p>
        <div className="lp-cta-btns">
          <button className="btn btn-primary btn-lg" onClick={() => scrollTo('contact')}>
            {t(content?.ctaPrimaryBtnText, lang) || t({ en: 'Start Free Trial →', zh: '開始免費試用 →' }, lang)}
          </button>
          <button className="btn btn-outline-light btn-lg" onClick={() => scrollTo('classes')}>
            {t(content?.ctaSecondaryBtnText, lang) || t({ en: 'Explore Classes', zh: '探索課程' }, lang)}
          </button>
        </div>
        <div className="lp-cta-note">
          {t(content?.ctaNote, lang) || t({ en: '14-day free trial · No credit card required · Cancel anytime', zh: '14 天免費試用 · 無需信用卡 · 隨時取消' }, lang)}
        </div>
      </div>
    </div>
  );
}
